import React from "react";
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";
import CHBodyHowitWorks from "./Components/BodyHowitWorks";

class CHHowitWorks extends React.Component {
  render() {
    return (
      <>
        <Nav />
        <CHBodyHowitWorks />
        <Footer />
      </>
    );
  }
}

export default CHHowitWorks;
